import React, { useCallback, useEffect, useState } from "react";
import { CardItem } from "../../common/Card/Card";
import Pagination from "../../common/Pagination";
import CssLoader from '../../components/cssloader/CssLoader';
import { matchesService } from "../../services/MatchesService";
import { ICategoryArticle } from "../../helpers/interfaces/ranking";
import { CardBodyHorizontal } from "../../common/Card/CardBody";
import Advertising from "../../common/Advertising";
import { Card } from "react-bootstrap";
import Link from "../../common/Link";
import { menuItem } from "../../helpers/interfaces";
import './blog.css';
import PageMeta from "../../components/PageMeta";

type Props = menuItem

export default function BlogPage(props: Props) {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [categoryId, setCategoryId] = useState<string | null>(props.categoria);
    const [categoryLabel, setCategoryLabel] = useState<string | null>(props.label);
    const [blogCards, setBlogCards] = useState<CardItem[]>([]);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const pageLimit = 20;
    const pageNeighbours = 5;

    const fetchArticles = useCallback(async (categoryId: string) => {
        setIsLoading(true);

        try {
            const data = await matchesService.getCategoryNews(categoryId, pageLimit, currentPage);

            if (data && typeof data !== "string") {
                setTotalRecords(data.totalCount);
                setBlogCards(mapArticoliToCardItems(data.articoli));
            }
        } catch (error) {
            console.error("Error fetching team articles: ", error);
        } finally {
            setIsLoading(false);
        }
    }, [currentPage]);

    useEffect(() => {
        if (
            !categoryId &&
            props.sub.length > 0 &&
            props.sub[0].sub.length > 0
        ) {
            setCategoryId(props.sub[0].sub[0].categoria)
            setCategoryLabel(props.sub[0].sub[0].label);
        }

        if (categoryId && currentPage) {
            fetchArticles(categoryId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoryId, currentPage, fetchArticles])

    const mapArticoliToCardItems = (data: ICategoryArticle[]): CardItem[] => {
        return data.map((articolo: ICategoryArticle) => ({
          id: 'articolo_' + articolo.id,
          title: articolo.titolo,
          subtitle: <>{articolo.strDataPubblicazione} - <span className="author-name">{articolo.nomeAutore}</span></>,
          image: articolo.img1,
          //altImageText: `Immagine di ${articolo.titolo}`,
          content: articolo.articoloBreve,
          link: `/articolo/${articolo.id}`,
          linkTitle: "Leggi la notizia",
          //idCategoria: parseInt(articolo.idCategoria, 10),
          /*societa: [
            {
              id: articolo.idSocieta,
              nome: articolo.nomeSocieta,
              logo: articolo.logo,
            },
          ],*/
        }));
    };

    let count = 0;

    return <>
        <PageMeta
            title={`Articoli ${categoryLabel} - Calcio a 5 Live`}
            description=""
            image=""
            url={document.location.href}
            type=""
        />
        <div id="blog">
        <h1>Articoli {categoryLabel}</h1>
        <div id="blog_news">
            {blogCards && blogCards.length > 0 ? blogCards.map((
                card: CardItem,
                index: number
            ) => {
                count++;

                return <React.Fragment key={index}>
                    <Card id={`${card.id}_${(card ? card : String(index))}`}>
                        <Card.Body className="px-2">
                            {CardBodyHorizontal(card)}
                        </Card.Body>
                    </Card>
                    {count % 4 === 0 && count < blogCards.length ? <>
                        {count === 4 && <Advertising code="banner-cat4" as="div" />}
                        {count === 8 && <Advertising code="banner-cat5" as="div" />}
                        {count === 12 && <Advertising code="banner-cat6" as="div" />}
                        {count === 16 && <Advertising code="banner-cat7" as="div" />}
                    </> : <></>}
                </React.Fragment>
            }) : <div>Nessuna card da visualizzare</div>}
        </div>
        
        <div className="py-3">
            <Pagination
                totalRecords={totalRecords}
                pageLimit={pageLimit}
                pageNeighbours={pageNeighbours}
                currentPage={currentPage}
                onPageChanged={setCurrentPage}
                maxPages={5}
            />
            <Link
                href={'/articoli/altre-categorie/archivio'}
                state={{categoryId}}
                title="Consulta l'archivio completo"
            >
                Consulta l'archivio completo
            </Link>
        </div>

        <CssLoader active={isLoading} text='Caricamento degli articoli in corso...' />
    </div>
    </>
}